import { mapActions, mapGetters } from 'vuex';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import marketBiggestGainsElement from '@/components/market/market-biggest-gains-element/market-biggest-gains-element.vue';
import { BiggestGainsLoader as biggestGainsLoader } from '@/components/content-loader';
import { range } from 'lodash';

const REFRESH_ENABLED = true;
const REFRESH_INTERVAL = 10 * 60 * 1000;

export default {
  components: {
    swiper,
    swiperSlide,
    marketBiggestGainsElement,
    biggestGainsLoader,
  },
  props: {
    extended: { type: Boolean, default: false },
  },
  data() {
    return {
      isComponentReady: false,
      activeIndex: 0,
      interval: null,
      swiperOptions: {
        spaceBetween: 0,
        autoplay: 10 * 1000,
        slidesPerColumn: 1,
        loop: true,
        direction: 'horizontal',
        onTransitionStart: (swp) => {
          this.activeIndex = swp.activeIndex;
        },
      },
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    ...mapGetters('widgets', ['getWidget']),
    gainsData() {
      return this.getWidget('biggest-gains').data || [];
    },
    lossesData() {
      return this.getWidget('biggest-losses').data || [];
    },
    classModifiers() {
      return {
        'market-biggest-gains': true,
        'market-biggest-gains--extended': this.extended,
      };
    },
    dummyComponents() {
      if (this.isLayoutMobile) return range(0, 1);
      return range(0, 2);
    },
    items() {
      const results = [];
      if (this.isLayoutDesktop) {
        if (this.gainsData.length) results.push(this.gainsData[0]);
        if (this.lossesData.length) results.push(this.lossesData[0]);
      } else {
        if (this.gainsData.length) results.push(this.gainsData);
        if (this.lossesData.length) results.push(this.lossesData);
      }
      return results;
    },
    shouldShowMobileSlider() {
      return this.items.length > 0 && !this.isLayoutDesktop;
    },
    shouldShowDesktopList() {
      return this.items.length > 0 && this.isLayoutDesktop;
    },
    prevArrowModifiers() {
      return {
        'market-biggest-gains__swiper-arrows__arrow': true,
        'market-biggest-gains__swiper-arrows__arrow--left': true,
      };
    },
    nextArrowModifiers() {
      return {
        'market-biggest-gains__swiper-arrows__arrow': true,
        'market-biggest-gains__swiper-arrows__arrow--right': true,
      };
    },
  },
  methods: {
    ...mapActions('widgets', ['fetchBiggestGains', 'fetchBiggestLoss']),
    prevSlide() {
      this.$refs['market-biggest-gains-slider'].swiper.slidePrev();
    },
    nextSlide() {
      this.$refs['market-biggest-gains-slider'].swiper.slideNext();
    },
    fetchData() {
      Promise.all([this.fetchBiggestGains(), this.fetchBiggestLoss()])
        .then(() => { this.isComponentReady = true; });
    },
  },
  mounted() {
    this.fetchData();
    if (REFRESH_ENABLED) {
      this.interval = setInterval(() => { this.fetchData(); }, REFRESH_INTERVAL);
    }
  },
  beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-biggest-gains/market-biggest-gains.js